import { createLogger, createStore } from 'vuex';

import type { AppStoreType } from '@emobg/vue-utils';
import { ENV } from '@emobg/web-utils';

import { App } from './App/index';
import { Broker } from './Broker/index';
import type { State } from './interfaces/state';
import { Steps } from './Steps/index';

export const store = createStore<State>({
  plugins: process.env.NODE_ENV !== ENV.production ? [createLogger()] : [],
  modules: {
    App,
    Broker,
    Steps,
  },
});

export function useStore() {
  return store as Store;
}

export type Store = AppStoreType<State>;
